(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["olenna-urgency"] && !Shopify.designMode) return;
  try {
    (function() {
  var DAYS_ES   = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MONTHS_ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function getSpainNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDate(d) {
    return '<span class="olenna-delivery-badge__day">' + DAYS_ES[d.getDay()] + ' ' + d.getDate() + ' de ' + MONTHS_ES[d.getMonth()] + '</span>';
  }

  // Dado un día de salida, calcula la fecha de entrega sumando N horas laborables
  // (salta fines de semana)
  function addDeliveryHours(dispatchDate, hours) {
    var result = new Date(dispatchDate);
    result.setHours(result.getHours() + hours);
    // Si cae en sábado (6) → lunes
    var dow = result.getDay();
    if (dow === 6) result.setDate(result.getDate() + 2);
    if (dow === 0) result.setDate(result.getDate() + 1);
    return result;
  }

  // Calcula el día de salida del pedido según la hora actual
  function getDispatchDate(now) {
    var day  = now.getDay();
    var hour = now.getHours();
    var min  = now.getMinutes();
    var sec  = now.getSeconds();
    var afterCutoff = (hour > 17) || (hour === 17 && (min > 0 || sec > 0));

    var dispatch = new Date(now);
    dispatch.setHours(12, 0, 0, 0); // mediodía del día de salida como base

    if (!afterCutoff) {
      // Antes de las 17:00
      if (day === 6)      dispatch.setDate(dispatch.getDate() + 2); // Sáb → Lun
      else if (day === 0) dispatch.setDate(dispatch.getDate() + 1); // Dom → Lun
      // Lun–Vie: sale hoy
    } else {
      // Después de las 17:00
      if (day === 5)      dispatch.setDate(dispatch.getDate() + 3); // Vie → Lun
      else if (day === 6) dispatch.setDate(dispatch.getDate() + 2); // Sáb → Lun
      else if (day === 0) dispatch.setDate(dispatch.getDate() + 1); // Dom → Lun
      else                dispatch.setDate(dispatch.getDate() + 1); // Lun–Jue → mañana
    }

    return { date: dispatch, afterCutoff: afterCutoff };
  }

  function initCountdown(el) {
    var prefixBefore  = el.dataset.prefixBefore  || 'Si haces el pedido antes de';
    var prefixMiddle  = el.dataset.prefixMiddle  || 'lo recibirás entre el';
    var prefixBetween = el.dataset.prefixBetween || 'y el';
    var afterCutoffTx = el.dataset.afterCutoff   || 'Tu pedido saldrá el lunes. Lo recibirás entre el';
    var iconColor     = getComputedStyle(el).getPropertyValue('--badge-icon-color').trim() || '#4a90c4';

    function icon(color) {
      return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    }

    function update() {
      var now      = getSpainNow();
      var cutoff   = new Date(now);
      cutoff.setHours(17, 0, 0, 0);
      var diff     = cutoff - now;

      var dispatch = getDispatchDate(now);
      var dateFrom = addDeliveryHours(dispatch.date, 24);
      var dateTo   = addDeliveryHours(dispatch.date, 72);

      if (!dispatch.afterCutoff && diff > 0) {
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        el.innerHTML = icon(iconColor) +
          '<span>' +
            prefixBefore +
            ' <span class="olenna-delivery-badge__timer">' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's</span> ' +
            prefixMiddle + ' ' + formatDate(dateFrom) + ' ' +
            prefixBetween + ' ' + formatDate(dateTo) +
          '</span>';
      } else {
        el.innerHTML = icon(iconColor) +
          '<span>' +
            afterCutoffTx + ' ' + formatDate(dateFrom) + ' ' +
            prefixBetween + ' ' + formatDate(dateTo) +
          '</span>';
      }
    }

    update();
    setInterval(update, 1000);
  }

  document.querySelectorAll('[id^="olenna-countdown-"]').forEach(initCountdown);
})();
  } catch(e) { console.error(e); }
})();

})();
